import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  excelCellValidationErrors: {},
  isCriticalityDropdownOpen: false,
  selectedRowIndex: 0,
  lastSelectedRowIndex: null,
};

export const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    setExcelCellValidationErrors: (state, { payload }) => {
      state.excelCellValidationErrors = payload || {};
    },
    setIsCriticalityDropdownOpen: (state, action) => {
      state.isCriticalityDropdownOpen = action.payload;
    },
    setSelectedRowIndex: (state, action) => {
      state.lastSelectedRowIndex = state.selectedRowIndex;

      state.selectedRowIndex = action.payload ?? 0;
    },
    setLastSelectedRowIndex: (state, action) => {
      state.lastSelectedRowIndex = action.payload;
    },
    resetTableState: () => {
      return initialState;
    },
  },
});

export const {
  setExcelCellValidationErrors,
  setIsCriticalityDropdownOpen,
  setLastSelectedRowIndex,
  setSelectedRowIndex,
  resetTableState,
} = tableSlice.actions;

export default tableSlice.reducer;
